import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { PortfolioSettingsDialog } from '~/components/portfolio/portfolio-settings-dialog.tsx';
import { getPortfolioOverviewQueryOptions } from '~/server/portfolio/query-options.ts';

export const Route = createFileRoute('/portfolios/$portfolioId/settings')({
	component: PortfolioSettingsPage,
});

function PortfolioSettingsPage() {
	const { portfolioId } = Route.useParams();
	const { data: loaderData } = useSuspenseQuery({
		...getPortfolioOverviewQueryOptions(Number(portfolioId)),
		refetchOnMount: false,
	});

	return <PortfolioSettingsDialog loaderData={loaderData} />;
}
